module.exports = __webpack_public_path__ + "img/sameday-badge.c2e50460.svg";